import React from 'react';
import { OC, FONT } from '../constants/index.js';
import { useTheme } from '../constants/index.js';

export function PageHero({ theme, eyebrow, title, accent, sub, children }) {
    const t = useTheme(theme);
    return React.createElement('section', {
        style: {
            padding: '56px 32px 48px',
            background: theme === 'dark' ? t.bg.page : '#FFFFFF',
            borderBottom: `1px solid ${t.border.base}`,
            position: 'relative',
            overflow: 'hidden',
        }
    },
        React.createElement('div', {
            style: {
                position: 'absolute', top: -160, left: '50%', width: 760, height: 560, marginLeft: -380, borderRadius: '50%',
                background: `radial-gradient(circle, ${theme === 'dark' ? 'rgba(249,115,22,.12)' : 'rgba(249,115,22,.07)'} 0%, transparent 65%)`,
                pointerEvents: 'none',
            }
        }),
        React.createElement('div', { style: { maxWidth: 760, margin: '0 auto', textAlign: 'center', position: 'relative' } },
            React.createElement('div', {
                style: {
                    fontFamily: FONT.mono, fontSize: 11.5, fontWeight: 600,
                    letterSpacing: '0.16em', textTransform: 'uppercase',
                    color: OC.orange, marginBottom: 14,
                }
            }, eyebrow),
            React.createElement('h1', {
                style: {
                    fontFamily: FONT.display, fontWeight: 800,
                    fontSize: 'clamp(32px, 5vw, 48px)', lineHeight: 1.06, letterSpacing: '-0.03em',
                    margin: 0, color: t.text.primary,
                }
            }, title, accent ? React.createElement('span', { style: { color: OC.orange } }, ` ${accent}`) : null),
            React.createElement('p', {
                style: { fontSize: 17, lineHeight: 1.55, color: t.text.secondary, margin: '18px auto 0', maxWidth: 600 }
            }, sub),
            children ? React.createElement('div', { style: { marginTop: 26, display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' } }, children) : null
        )
    );
}

export function renderSimpleMarkdown(text) {
    if (!text) return null;
    return text.split('\n\n').map((block, i) => {
        const trimmed = block.trim();
        if (!trimmed) return null;
        if (trimmed.startsWith('## ')) {
            return React.createElement('h2', {
                key: i,
                style: { fontFamily: FONT.display, fontWeight: 700, fontSize: 22, margin: '28px 0 10px', color: 'inherit' }
            }, trimmed.slice(3));
        }
        if (trimmed.startsWith('### ')) {
            return React.createElement('h3', {
                key: i,
                style: { fontFamily: FONT.display, fontWeight: 700, fontSize: 18, margin: '20px 0 8px', color: 'inherit' }
            }, trimmed.slice(4));
        }
        const lines = trimmed.split('\n').map((line) => {
            if (/^\d+\.\s/.test(line)) return line;
            return line.replace(/\*\*(.+?)\*\*/g, '$1');
        });
        return React.createElement('p', {
            key: i,
            style: { fontSize: 15.5, lineHeight: 1.65, color: 'inherit', margin: '0 0 14px', whiteSpace: 'pre-wrap' }
        }, lines.join('\n'));
    });
}
